import { required, SelectInput } from "react-admin";

const AdhocOperatorTarget = () => {
  return (
    <SelectInput
      source="target"
      choices={[
        { id: "driver", name: "Driver" },
        { id: "busAssistant", name: "Bus Assistant" },
        { id: "both", name: "Both" },
      ]}
      label="Adhoc Operator Target"
      validate={required()}
    />
  );
};

export default AdhocOperatorTarget;
